import * as React from "react";
import { hasSeasonRank } from "helpers/rank";
import { TooltipMemberContent } from "UIKit";
import { t } from "helpers/localization";

import settings from "settings";

export const getMemberTooltipContent = (member, currentAccount, isContextMenuEnabled, displayCheckboxes, disabledIds = []) => {
  let hasSeason = false;
  let memberRank = member.rank;
  let memberAchievement = '';

  if (hasSeasonRank(member.seasonRank, member.seasonId)) {
    hasSeason = true;
    memberRank = member.seasonRank;
    const seasonName = settings.seasonNames[member.seasonId];
    memberAchievement = t('%(rank)s ранг в сезоне %(seasonName)s', {
      rank: member.seasonRank,
      seasonName: seasonName
    });
  }

  const isOwn = currentAccount.id === member.id;
  const disabledCheckbox = displayCheckboxes && disabledIds.indexOf(member.id) !== -1;
  const leftMouseAction = isOwn ? null : (!displayCheckboxes || disabledCheckbox) ? 'send_message' : 'select';

  let needResource = 0;
  const isBonusActivated = isOwn ? currentAccount.isBonusActivated : member.isBonusActivated;
  const leveling = isOwn ? currentAccount.leveling : member.leveling;
  if (leveling && !isBonusActivated) {
    needResource = settings.supply.clanLevelingToAccountLeveling[leveling];
  }

  return <TooltipMemberContent name={member.name} rank={memberRank} hasSeason={hasSeason} achievement={memberAchievement} needResource={needResource} showSendMessage={leftMouseAction === 'send_message'} showSelect={leftMouseAction === 'select'} showRightMouse={isContextMenuEnabled && !isOwn} />;
};